import { render, staticRenderFns } from "./DetailMultipleAssignments.vue?vue&type=template&id=50238572"
import script from "./DetailMultipleAssignments.js?vue&type=script&lang=js&external"
export * from "./DetailMultipleAssignments.js?vue&type=script&lang=js&external"
import style0 from "./DetailMultipleAssignments.vue?vue&type=style&index=0&id=50238572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports